export default {
  d: "M220.8,435.5l-92.7-92.7H47.3V169.2h80.8l92.7-92.7L220.8,435.5L220.8,435.5z M268.1,218.9V11.5h-49.2\n\tL108.5,121.9H0v268.1h108.5l110.4,110.4h49.2V218.9l71.4-7.1l44.2,44.2l-61.3,61.3l33.5,33.5l61.3-61.3l61.3,61.3l33.5-33.5\n\tL450.7,256l61.3-61.3l-33.5-33.5l-61.3,61.3l-61.3-61.3l-33.5,33.5l17.1,17.1L268.1,218.9z",
  viewBox: "0 0 512 512"
}
